<template>
  <div class="image-upload-container">
    <div class="d-flex">
      <div>
        <!-- File Upload -->
        <input type="file" @change="onFileChange" accept="image/jpeg, image/png" ref="fileInput" />
        <p v-if="fileInputValue.length > 0">{{ fileInputValue }}</p>
      </div>

      <!-- Thumbnail -->
      <div class="thumb" v-if="thumbnailUrl" @click="showModal = true">
        <img :src="thumbnailUrl" alt="Thumbnail" />
      </div>
    </div>

    <!-- Modal Preview -->
    <div class="modal-overlay" v-if="showModal" @click.self="closeModal">
      <div class="modal-content">
        <span class="close-btn" @click="closeModal">&times;</span>
        <img :src="thumbnailUrl" alt="Full Preview" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SingleImageUploadModal",
  props: ["selectedFile"],
  data() {
    return {
      thumbnailUrl: this.selectedFile || "",
      showModal: false,
      fileInputValue: ""
    };
  },
  watch: {
    selectedFile(value) {
      console.log('selectedFile ####', value);
      this.$refs.fileInput.value = '';
      this.setImageOnInput(value);
    }    
  },
  methods: {
    async setImageOnInput(value) {

      const fileName = value.substring(value.lastIndexOf('/') + 1);
      /* const response = await fetch(value, { mode: 'cors' });
      const blob = await response.blob();
      const file = new File([blob], fileName, { type: blob.type });
      console.log('file:::', file);

      const dt = new DataTransfer();
      dt.items.add(file);
      let fileList = Array.from(dt.files);
      //this.fileInputValue = dataTransfer.files;
      console.log('fileList:::', fileList);
      
      //const input = document.querySelector('input[type="file"]');
      //input.files = fileList;
      //this.fileInputValue = fileList;//new FileList(file);
      this.$refs.fileInput.value = fileList; */
      this.fileInputValue = fileName;
      this.thumbnailUrl = value || "";
      this.$emit('imageFileSelect', this.fileInputValue);
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        //this.fileInputValue = event.target.files;
        this.thumbnailUrl = URL.createObjectURL(file);
        this.showModal = false; // Reset modal
        this.$emit('imageFileSelect', file);
        this.fileInputValue = "";
      } else {
        this.thumbnailUrl = null;
        this.showModal = false;
        alert("Please select a valid image file.");
      }
    },
    closeModal() {
      this.showModal = false;
    },
  },
};
</script>

<style scoped>
.image-upload-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
}

input[type="file"] {
  margin-bottom: 1rem;
}

.thumb {
  width: 100px;
  height: 100px;
  overflow: hidden;
  border: 1px solid #ccc;
  cursor: pointer;
}

.thumb img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}


/* Modal styles */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  background: #fff;
  padding: 1rem;
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: auto; */
}

.modal-content img {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  object-fit: contain;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  font-size: 2rem;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/partners/ImageUpload.vue